import { openBlock as a, createElementBlock as t, createElementVNode as h } from "vue";
const e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, c = /* @__PURE__ */ h("path", {
  fill: "#F0F0F0",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), o = /* @__PURE__ */ h("path", {
  fill: "#0052B4",
  d: "M39.829 17.391a19.91 19.91 0 0 0-5.687-11.533A19.91 19.91 0 0 0 22.61.17v17.22h17.22ZM17.391.171A19.91 19.91 0 0 0 5.858 5.858 19.912 19.912 0 0 0 .17 17.39h17.22V.171ZM.171 22.609a19.911 19.911 0 0 0 5.687 11.533A19.912 19.912 0 0 0 17.39 39.83V22.61H.171Zm22.438 17.22a19.91 19.91 0 0 0 11.533-5.687A19.91 19.91 0 0 0 39.83 22.61H22.61v17.22Z"
}, null, -1), n = /* @__PURE__ */ h("path", {
  fill: "#F0F0F0",
  d: "M26.827 12.69c0-.265.216-.482.482-.482h1.034a2.965 2.965 0 0 0 2.961-2.961 2.965 2.965 0 0 0-2.961-2.962h-.982c-.32-.24-.75-.389-1.223-.389-.989 0-1.79.641-1.79 1.432 0 .783.786 1.418 1.761 1.43v.006h2.234a.483.483 0 0 1 0 .965h-1.034a2.965 2.965 0 0 0-2.961 2.961 2.965 2.965 0 0 0 2.962 2.962h3.994v-2.48H27.31a.482.482 0 0 1-.483-.482Zm-15.652 0c0-.265.216-.482.482-.482h1.034a2.965 2.965 0 0 0 2.961-2.961 2.965 2.965 0 0 0-2.961-2.962h-.982c-.32-.24-.75-.389-1.223-.389-.989 0-1.79.641-1.79 1.432 0 .783.786 1.418 1.761 1.43v.006h2.233a.483.483 0 0 1 0 .965h-1.033a2.965 2.965 0 0 0-2.961 2.961 2.965 2.965 0 0 0 2.961 2.962h3.995v-2.48h-3.995a.482.482 0 0 1-.482-.482Zm15.652 18.452c0-.266.216-.482.482-.482h1.034a2.965 2.965 0 0 0 2.961-2.962 2.965 2.965 0 0 0-2.961-2.961h-.982c-.32-.24-.75-.39-1.223-.39-.989 0-1.79.642-1.79 1.433 0 .783.786 1.418 1.761 1.43v.006h2.233a.483.483 0 0 1 0 .964H27.31a2.965 2.965 0 0 0-2.961 2.962 2.965 2.965 0 0 0 2.961 2.962h3.995v-2.48H27.31a.483.483 0 0 1-.483-.482Zm-15.652 0c0-.266.216-.482.482-.482h1.034a2.965 2.965 0 0 0 2.961-2.962 2.965 2.965 0 0 0-2.961-2.961h-.982c-.32-.24-.75-.39-1.223-.39-.989 0-1.79.642-1.79 1.433 0 .783.786 1.418 1.761 1.43v.006h2.233a.483.483 0 0 1 0 .964h-1.033a2.965 2.965 0 0 0-2.961 2.962 2.965 2.965 0 0 0 2.961 2.962h3.995v-2.48h-3.995a.482.482 0 0 1-.482-.482Z"
}, null, -1), l = [
  c,
  o,
  n
];
function s(i, r) {
  return a(), t("svg", e, [...l]);
}
const d = { render: s };
export {
  d as default,
  s as render
};
